import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M7 12a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v6H7v-6Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2H5v-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M21 12h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18.5 4.5 18 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 12h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4.929 4.929.707.707", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12v6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Siren";
const Siren = memo(themed(Icon));
export {
  Siren
};
//# sourceMappingURL=siren.js.map
